// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_ak-0";
export var optionCard = "_ak-1";